import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense } from "react";
import { FooterContent } from "./FooterContent";
import menu_model from "@iscr/models/menu_model";
const SiteInformation = lazy(() => import("./SiteInformation"));
import { get_next_wl_link } from "@iscr/views/med/utils";
const Footer = () => {
    var _a, _b, _c, _d, _e;
    if ((_b = (_a = app.user.prof) === null || _a === void 0 ? void 0 : _a.xtra) === null || _b === void 0 ? void 0 : _b.kiosk) {
        return null;
    }
    const serviceMenu = menu_model.get_servicesmenu();
    const showKetch = __KETCH_DISPLAY__;
    const showExtra = app.dev_env || ((_c = app.acl) === null || _c === void 0 ? void 0 : _c.is_admin) || ((_d = app.acl) === null || _d === void 0 ? void 0 : _d.is_supp) || ((_e = app.acl) === null || _e === void 0 ? void 0 : _e.is_mark);
    return (_jsxs("div", { className: "text-white bg-is2-blue-900", children: [_jsx(FooterContent, { servicesMenu: serviceMenu, showKetch: showKetch, showSiteInfo: !showExtra, wl_link: get_next_wl_link() }), showExtra && (_jsx(Suspense, { fallback: null, children: _jsx(SiteInformation, {}) }))] }));
};
export default Footer;
